import React, { useCallback, useContext, useEffect, useState } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { FirstTimeFlag } from '../../../redux/firstTimeFlags';
import { useFirstTimeFlag } from '../../../redux/firstTimeFlags/hooks';
/** A context provider that moves the deviation page through the two stages
 *  displayed for the IsMsSubscriptionNotPurchased flag.
 *
 *  The first stage, 'overlay' displays a congrats overlay over the devpage
 *  artstage and, when that's clicked, goes to the next stage 'tooltips'
 *  where the tooltips above the download button and the SubscribersOnly
 *  badge open until the window is clicked or scrolled.
 */
export var SubscriptionPurchaseFTUEContext = React.createContext(null);
SubscriptionPurchaseFTUEContext.displayName = 'SubscriptionPurchaseFTUEContext';
export var SubscriptionPurchaseFTUEContextProvider = function (_a) {
    var deviation = _a.deviation, children = _a.children;
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    var _b = useSubscriptionTier(deviation), isInTier = _b.isInTier, isOwner = _b.isOwner, isUserSubscribed = _b.isUserSubscribed, isSubscribedButBlocked = _b.isSubscribedButBlocked;
    var _c = useFirstTimeFlag(FirstTimeFlag.IsMsSubscriptionNotPurchased), IsMsSubscriptionNotPurchased = _c.hasFlag, dropFlag = _c.dropFlag;
    var isFTUEShown = isLoggedIn &&
        isInTier &&
        isUserSubscribed &&
        !isOwner &&
        !isSubscribedButBlocked &&
        IsMsSubscriptionNotPurchased;
    var initialPhase = isFTUEShown ? 'overlay' : null;
    var _d = useState(initialPhase), ftuePhase = _d[0], setFtuePhase = _d[1];
    var moveToNextFtuePhase = useCallback(function () {
        if (ftuePhase === 'overlay') {
            dropFlag();
            setFtuePhase('tooltips');
        }
        else {
            setFtuePhase(null);
        }
    }, [ftuePhase, dropFlag]);
    // when we're in the overlay phase, listen for any click or scrolling
    // and then move to the next phase
    /* eslint-disable @wix/da/window-object-typeof-check */
    useEffect(function () {
        if (ftuePhase !== 'overlay') {
            return;
        }
        // any click and doesn't matter if it propagates
        window.addEventListener('click', moveToNextFtuePhase, { once: true });
        window.addEventListener('scroll', moveToNextFtuePhase, { once: true });
        return function () {
            window.removeEventListener('click', moveToNextFtuePhase);
            window.removeEventListener('scroll', moveToNextFtuePhase);
        };
    }, [ftuePhase, moveToNextFtuePhase]);
    // /* eslint-enable @wix/da/window-object-typeof-check */
    // in the tooltips phase, listen for any click and then end the ftue
    /* eslint-disable @wix/da/window-object-typeof-check */
    useEffect(function () {
        if (ftuePhase !== 'tooltips') {
            return;
        }
        window.addEventListener('click', moveToNextFtuePhase, { once: true });
        return function () {
            window.removeEventListener('click', moveToNextFtuePhase);
        };
    }, [ftuePhase, moveToNextFtuePhase]);
    /* eslint-enable @wix/da/window-object-typeof-check */
    return (React.createElement(SubscriptionPurchaseFTUEContext.Provider, { value: ftuePhase }, children));
};
SubscriptionPurchaseFTUEContextProvider.displayName =
    'SubscriptionPurchaseFTUEContextProvider';
//# sourceMappingURL=SubscriptionPurchaseFTUEContext.js.map